module.exports = __webpack_public_path__ + "img/sharetext.881696b9.png";